<template>
  <v-modal
    name="localModal"
    classes="v--modal vmodal-container"
    :height="height"
    :scrollable="true"
    @closed="closeModal"
    transition="nice-modal-fade"
    :adaptive="true"
    :clickToClose="clickToClose"
    v-bind="$attrs"
  >
    <div slot="top-right">
      <md-button @click="closeModal" class="md-round md-just-icon md-danger" v-if="clickToClose">
        <md-icon>close</md-icon>
      </md-button>
    </div>

    <slot></slot>
  </v-modal>
</template>

<script>
export default {
  name: "VeeModalComp",

  props: {
    clickToClose: {
      type: Boolean,
      default: true,
    },
    height: {
      type: [String, Number],
      default: "auto",
    },
  },

  methods: {
    closeModal: function () {
      this.$modal.hide("localModal");
      this.$emit("close");
    },
  },

  mounted() {
    this.$modal.show("localModal");
  },
};
</script>

<style lang="scss" scoped>
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */
.modal-container {
  width: 850px;
}
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.sweet-modal-overlay {
  z-index: 4;
}

.v--modal-overlay {
  z-index: 55;
}

.vmodal-container {
  z-index: 4;
  // -webkit-transform: scale(1.1);
  // transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/components/SimpleModal.vue